<template>  
  <modal v-model="show"
          max-width="min-content"
          :has-padding="false"
          content-class="round-body-content">   
    <button v-if="!$slots.default"
            class="btn btn-primary btn-extra-round"
            slot="activator">
     {{$t('message.integrations.message.createIntegration')}}
    </button>
    <slot slot="activator"></slot>

    <div class="wrapper" :key="id">
      <app-integration-form :integration="integration"
                            :code="code"
                            ref="body"
                            @registered="emitRegistered"
                            @set-integration="setIntegration"></app-integration-form>
    </div>
  </modal>
</template>

<script>
import EventBus from "@packages/event-bus/index";
import AppIntegrationForm from "./components/IntegrationForm";
import Modal from "@/components/generic/Modal";

export default {
  components: {
    AppIntegrationForm,
    Modal
  },

  data() {
    return {
      submitButtonText: this.$t('message.generics.message.advance'),
      id: null,
      show: false,
    };
  },

  props: {
    integration: {
      type: Object,
    },
    code: {
      type: String,
    },
  },

  mounted() {
    if (this.code) {
      this.show = true;
    }
  },

  methods: {
    validate() {
      // eslint-disable-next-line no-console
      this.$refs.body.validate();
    },
    autorizar() {
      window.open(this.data.configuration.authorization_url.value, "_blank");
      this.show = false;
    },

    input(value) {
      this.data = value;
    },

    emitRegistered() {
      this.$emit("registered");
      EventBus.$emit("LOAD_INTEGRATION");
      this.closeModal();
    },

    closeModal() {
      EventBus.$emit("RESE_INTEGRATION_FORM");
      this.show = false;
    },
    setIntegration(integration) {
      this.$emit("set-integration", integration);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-dialog__content {
  border-radius: 5px;
}
.modal {
  border-radius: 5px;
}

button {
  margin: 5px;
}

.v-stepper {
  overflow: visible !important;
  overflow-y: visible !important;
}
.wrapper {
  padding: 10px !important;
  min-width: 400px !important;
}

.card-footer {
  text-align: center;
}
</style>
